module.exports = __webpack_public_path__ + "img/EXV_SD_Nav-Icon_Gewinner.61101aa3.svg";